/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ref_N3Inputs */

const en_diff_ref_n3 = /** @type {(inputs: Diff_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The path exists on both sides with different values. Old is listed first, then new.`)
};

const ko_diff_ref_n3 = /** @type {(inputs: Diff_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경로가 양쪽에 있고 값이 다릅니다. 이전 값이 먼저, 새 값이 다음에 나옵니다.`)
};

const ja_diff_ref_n3 = /** @type {(inputs: Diff_Ref_N3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスが両側にあり値が異なります。古い値が先、新しい値が後に並びます。`)
};

/**
* | output |
* | --- |
* | "The path exists on both sides with different values. Old is listed first, then new." |
*
* @param {Diff_Ref_N3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ref_n3 = /** @type {((inputs?: Diff_Ref_N3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ref_N3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ref_n3(inputs)
	if (locale === "ko") return ko_diff_ref_n3(inputs)
	return ja_diff_ref_n3(inputs)
});